import React from 'react';

const ShowMoreIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-show-more" />
    </div>
  );
};

export default ShowMoreIcon;
